import { USER_SSO_CONFIG_KEY } from '../../session/constants.ts';
import type { UserSSOConfig } from '../../session/types.ts';

export const loadSSOConfig = (): UserSSOConfig | null => {
  const ssoConfigString = localStorage.getItem(USER_SSO_CONFIG_KEY);
  if (!ssoConfigString) {
    return null;
  }
  return JSON.parse(ssoConfigString) as UserSSOConfig;
};

export const storeSSOConfig = (config: UserSSOConfig): void => {
  if (!config) {
    return;
  }
  localStorage.setItem(USER_SSO_CONFIG_KEY, JSON.stringify(config));
};
